import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
};

const getInitialLanguage = () => {
  if (window.selectedLanguage) {
    return window.selectedLanguage;
  }
  const storedLang = localStorage.getItem("i18nextLng");
  if (storedLang) {
    return storedLang;
  }
  return "en";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
  });

document.addEventListener("languageChanged", (event) => {
  if (event.detail && i18n.language !== event.detail) {
    i18n.changeLanguage(event.detail);
  }
});

export default i18n;
